import { useReduxActions } from './../hooks/useRedux';
import {
  SHIPMENT_EXECUTION_SET_FILTER,
  SHIPMENT_EXECUTION_RESET_FILTER,
  SHIPMENT_EXECUTION_RESET_MORE_FILTER,
  SHIPMENT_EXECUTION_PAGINATION,
  SHIPMENT_EXECUTION_ENABLE_LOADING,
  SHIPMENT_EXECUTION_DISABLE_LOADING,
  SHIPMENT_EXECUTION_UPDATE_DATA,
  SHIPMENT_EXECUTION_APPLY_FILTER,
  SHIPMENT_EXECUTION_CANCEL_FILTER,
  SHIPMENT_EXECUTION_SET_PREV_PAGINATION,
  SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA,
  SHIPMENT_CONTAINER_FETCHING_DATA,
  SHIPMENT_EXECUTION_MILESTONE_COUNT,
  SHIPMENT_EXECUTION_TOGGLE_WATCH,
  SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA,
  SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING,
  SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING,
  SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX,
  SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS,
  SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT,
  SHIPMENT_EXECUTION_SET_SI_DETAILS,
  SHIPMENT_EXECUTION_SET_SI_LOADING,
  SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING,
  SHIPMENT_EXECUTION_SET_VGM_REQUESTS,
  SHIPMENT_EXECUTION_SET_VGM_DETAILS,
  SHIPMENT_EXECUTION_SET_VESSEL_MASTER,
  SHIPMENT_EXECUTION_SET_FORM13_REQUESTS,
  SHIPMENT_EXECUTION_SET_FORM13_DETAILS,
  SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS,
} from './constants';

import {
  fetchAllShipment as fetchAllShipmentAPI,
  fetchAllContainersForShipment,
  fetchAllBLsForShipment,
  fetchDocumentsApi,
  getSEDropdownMasters,
  getShipmentDetails,
  fetchShipmentInstructions,
  fetchShipmentInstructionsPendingCount,
  fetchShipmentInstructionsDetails,
  fetchVGMRequests,
  fetchVGMDetails,
  fetchAllForm13Requests,
  fetchForm13Request,
  getExecutionMilestoneCount
} from '../api/shipmentExecution';
import { getLastSortedColumnValue } from 'src/utils/pagination';
import moment from 'moment';
import { CT_POLLING_FREQUENCY } from 'src/globals';
import { getDuration } from 'src/utils/utils';
import { trackingCardDataList } from 'src/components/pages/shipment-execution/SE.utils';
import { SEOrgType } from 'src/components/pages/shipment-execution/SE.interfaces';
import ApiDto from 'src/dto/ApiDto';
import { isValidArray } from 'src/Library/Helper';
import { batch } from 'react-redux';
let pollingAgent: any = null;

export const shipmentSetFilter = val => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_SET_FILTER,
    data: val,
  });
};

export const cancelFilter = type => () => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_CANCEL_FILTER,
  });
};

export const shipmentApplyFilter = type => (noRender = false) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_APPLY_FILTER,
  });
  if (!noRender) {
    dispatch(fetchAllShipment(type));
  }
};

export const shipmentResetFilter = type => (hitApi = false) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_RESET_FILTER,
  });
  if (!hitApi) {
    dispatch(fetchAllShipment(type));
  }
};

export const shipmentResetFilterWithOutAPI = type => () => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_RESET_FILTER,
  });
  dispatch(fetchAllShipment(type));
};

export const shipmentResetMoreFilter = (type: SEOrgType) => (hitApi = false) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_RESET_MORE_FILTER,
  });
  if (!hitApi) {
    dispatch(fetchAllShipment(type));
  }
};

export const shipmentSetPagination = type => val => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_PAGINATION,
    data: val,
  });
  dispatch(fetchAllShipment(type));
};

export const setPrevPagination = type => () => async (dispatch, getState) => {
  dispatch({
    type: SHIPMENT_EXECUTION_SET_PREV_PAGINATION,
  });
  dispatch(fetchAllShipment(type));
};
/**
 * Returns a trigger event to be sent to the backend.
 */
export const isShipmentSessionActivated = () => {
  /* Return 'shipmentSessionActivated' if more than 30 minutes have elapsed
     since the time it was sent last */
  const TSKey = 'fetchAllShipmentTimeStamp';
  const TSStr = localStorage.getItem(TSKey);
  const TS = parseInt(TSStr ? TSStr : '0', 10);
  const now = moment().unix();
  if (now - TS > 1800) {
    localStorage.setItem(TSKey, JSON.stringify(moment().unix()));
    return true;
  }
  return false;
};
export const fetchAllShipment = viewType => async (dispatch, getState) => {
  if (viewType) {
    dispatch({
      type: SHIPMENT_EXECUTION_ENABLE_LOADING,
    });
    const appliedFilters = getState().shipmentExecutionReducer.appliedFilters;
    // For Filters
    const originList = appliedFilters.polList ?
      appliedFilters.polList.map(filter => filter.key) : [];
    const destinationList = appliedFilters.podList ?
      appliedFilters.podList.map(filter => filter.key) : [];
    const ffIdList = appliedFilters.ffIdList ? appliedFilters.ffIdList : [];
    const transporterIdList = appliedFilters.transporterIdList ? appliedFilters.transporterIdList : [];
    const ffGroupIdList = appliedFilters.ffGroupIdList ? appliedFilters.ffGroupIdList : [];
    const chaIdList = appliedFilters.chaIdList ? appliedFilters.chaIdList : [];
    const customerIdList = appliedFilters.customerIdList ? appliedFilters.customerIdList : [];
    const shipperIdList = appliedFilters.shipperList ? appliedFilters.shipperList : [];
    const descendingOrder = appliedFilters.descendingOrder;
    const typeList = appliedFilters.typeList ? appliedFilters.typeList : [];
    const milestone = appliedFilters.milestone;
    const shipmentSessionActivated = isShipmentSessionActivated();
    const pagination = getState().shipmentExecutionReducer.pagination;
    const siInttraStatusList = appliedFilters.siInttraStatusList || [];
    const companyCodeList = appliedFilters.companyCodeList;
    const incotermList = appliedFilters.incotermList;
    const userList = (appliedFilters.userList|| [])?.map(item => item.key);
    const teamList = (appliedFilters.teamList|| [])?.map(item => item.key);
    const modeList = appliedFilters.modeList;
    const myTaskList = appliedFilters.myTaskList;
    const cargoTypeList = appliedFilters.cargoTypeList;
    const productKeyList = (appliedFilters.productKeyList || []).map(obj => obj.key);
    const poNumberList = appliedFilters.poNumberList;
    const myTaskStatusFilterList = appliedFilters?.myTaskStatusFilterList;
    const myTaskNameFilterList =  appliedFilters?.myTaskNameFilterList;
    const hideDeleted = appliedFilters.hideDeleted;
    const supplierIdList = (appliedFilters.supplierIdList || [])?.map(item => item.key);

    const apiCallObject/*: typeof ApiDto.FetchAllShipmentsV2Dto*/ = {
      viewType,
      shipmentSessionActivated,
      originList,
      typeList,
      destinationList,
      ffIdList,
      transporterIdList,
      ffGroupIdList,
      chaIdList,
      customerIdList,
      shipperIdList,
      productKeyList,
      poNumberList,
      // statusList,
      descendingOrder,
      siInttraStatusList,
      milestone,
      shipmentIdList: appliedFilters.shipmentIdList,
      clientReferenceNumberList: appliedFilters.clientReferenceNumberList,
      bookingNumberList: appliedFilters.bookingNumberList,
      [appliedFilters.dateFilter]: appliedFilters.dateRangeFilter ? JSON.stringify(appliedFilters.dateRangeFilter) : undefined,
      sortBy: appliedFilters.sortBy,
      lastRowId: getLastColumnId(pagination),
      lastSortedColumnValue: getLastSortedColumnValue(pagination),
      currentPageNumber: pagination.currentPageNumber,
      resultPerPage: Number(pagination.resultPerPage),
      nextOrPrev: pagination.nextOrPrev,
      hasTracking: appliedFilters.hasTracking,
      carrierCodeList: appliedFilters.carrierCodeList,
      plantIdList: appliedFilters.plantIdList,
      companyCodeList,
      modeList,
      incotermList,
      userList,
      teamList,
      myTaskList,
      cargoTypeList,
      myTaskStatusFilterList,
      myTaskNameFilterList,
      hideDeleted,
      supplierIdList
    };
    const response = await fetchAllShipmentAPI(apiCallObject);

    if (response.isSuccess) {
      dispatch({
        type: SHIPMENT_EXECUTION_UPDATE_DATA,
        data: response.data,
      });
    } else {
    }

    dispatch({
      type: SHIPMENT_EXECUTION_DISABLE_LOADING,
    });
    dispatch({
      type: SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS,
      data: {},
    });

    getExecutionMilestoneCount({
      viewType,
      originList,
      typeList,
      destinationList,
      ffIdList,
      transporterIdList,
      chaIdList,
      customerIdList,
      productKeyList,
      poNumberList,
      shipperIdList,
      shipmentIdList: appliedFilters.shipmentIdList,
      clientReferenceNumberList: appliedFilters.clientReferenceNumberList,
      bookingNumberList: appliedFilters.bookingNumberList,
      [appliedFilters.dateFilter]: appliedFilters.dateRangeFilter ? JSON.stringify(appliedFilters.dateRangeFilter) : undefined,
      hasTracking: appliedFilters.hasTracking,
      carrierCodeList: appliedFilters.carrierCodeList,
      plantIdList: appliedFilters.plantIdList,
      companyCodeList,
      modeList,
      incotermList,
      userList,
      teamList,
      myTaskList,
      cargoTypeList,
      siInttraStatusList: appliedFilters.siInttraStatusList || [],
      myTaskStatusFilterList,
      myTaskNameFilterList,
      supplierIdList,
      includeTaskStatusFilterCount : true
    }).then((milestoneCountResponse) => {
      if (milestoneCountResponse.isSuccess) {
        dispatch({
          type: SHIPMENT_EXECUTION_MILESTONE_COUNT,
          data: milestoneCountResponse.data,
        });
      }
    });
  } else {
    throw new Error('Type cannot be null');
  }
};
const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const enableLoadTracking = () => {
  return {
    type: SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING,
  };
}

export const disableLoadTracking = () => {
  return {
    type: SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING,
  };
}

export const fetchTrackingData = (executionNumber: string, fromContainer = false) => async (dispatch, getState) => {
  if (!fromContainer) {
    dispatch(stopTrackingPolling());
  }
  dispatch({
    type: SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING,
  });
  const responseContainer = await fetchAllContainersForShipment(executionNumber);
  const responseBL = await fetchAllBLsForShipment(executionNumber);
  if ((responseContainer.isSuccess || responseBL.isSuccess)) {
    dispatch({
      type: SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA,
      data: {
        containerList: trackingCardDataList(responseContainer.data, 'CONTAINER'),
        blList: trackingCardDataList(responseBL.data, 'BL'),
      },
    });
    if (!fromContainer) {
      dispatch(startTrackingPoller(executionNumber));
    }
  }
  dispatch({
    type: SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING,
  });
};

export const pollTrackingApi = (executionNumber: string, refresh = false) => async (dispatch, getState) => {
  const containerData = getState().shipmentExecutionReducer.containerData;
  const currentData = containerData && containerData.containerList;
  if (!refresh && currentData && currentData.filter(elem => !elem.isTrackingPresent).length === 0
    &&
    currentData.filter(elem => (elem.disableRefreshRequest &&
      ((getDuration(elem && elem.disableRefreshRequest) || -1) < 5))).length === 0) {
    dispatch(stopTrackingPolling());
    return;
  }
  const responseContainer = await fetchAllContainersForShipment(executionNumber);
  const responseBL = await fetchAllBLsForShipment(executionNumber);

  if ((responseContainer.isSuccess || responseBL.isSuccess) && pollingAgent) {
    dispatch({
      type: SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA,
      data: {
        containerList: trackingCardDataList(responseContainer.data, 'CONTAINER'),
        blList: trackingCardDataList(responseBL.data, 'BL'),
      },
    });
    dispatch(stopTrackingPolling());
    dispatch(startTrackingPoller(executionNumber));
  }
};

export const showFetchingData = (data: any) => async (dispatch) => {
  dispatch({
    data,
    type: SHIPMENT_CONTAINER_FETCHING_DATA,
  });
};

export const startTrackingPoller = (body, refresh = false) => async (dispatch) => {
  if (!pollingAgent) {
    pollingAgent = setTimeout(() => {
      dispatch(pollTrackingApi(body, refresh));
    }, refresh ? 5000 : CT_POLLING_FREQUENCY);
  }
};

export const stopTrackingPolling = () => async (dispatch) => {
  if (pollingAgent) {
    clearTimeout(pollingAgent);
    pollingAgent = undefined;
  }
};

export const toggleShipmentWatch = (data:
  {
    index: Number,
    watcherList: string[],
    isWatching: boolean
  }) => async (dispatch) => {
    dispatch({
      type: SHIPMENT_EXECUTION_TOGGLE_WATCH,
      data,
    })
  }
export const fetchDocuments = apiParams => async (filterParams) => {
  const response = await fetchDocumentsApi(
    apiParams.id,
    filterParams,
  );

  return response;
};

export const fetchDropdownMasterdata = (shipmentId: string) => async dispatch => {
  const response = await getSEDropdownMasters(shipmentId);

  if (response.isSuccess) {
    dispatch({
      data: response.data,
      type: SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA, 
    });
  }
}

export const updateCardDataAtIndex = ({
  index,
  shipmentId,
  type,
}: {
  index: number;
  shipmentId: string | number;
  type: SEOrgType;
}) => async (dispatch) => {
  const response = await getShipmentDetails({ shipmentId, viewType: type });
  if (response.isSuccess) {
    dispatch({
        type: SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX,
        data: {
          cardData: response.data,
          index,
        },
      });
  } else if (response.errorMessage === 'Access Denied') {
    dispatch(fetchAllShipment(type));
  } 
}

export const useSEActions = (type) => {
  return useReduxActions({
    shipmentSetFilter,
    cancelFilter: cancelFilter(type),
    shipmentApplyFilter: shipmentApplyFilter(type),
    shipmentResetFilter: shipmentResetFilter(type),
    shipmentResetFilterWithOutAPI: shipmentResetFilterWithOutAPI(type),
    shipmentSetPagination: shipmentSetPagination(type),
    setPrevPagination: setPrevPagination(type),
    // fetchAllShipment = viewType => async (dispatch, getState)
    fetchTrackingData,
    pollTrackingApi,
    showFetchingData,
    startTrackingPoller,
    stopTrackingPolling,
  });
};

const getIndexWiseShipmentActions = (index, response) => {
  switch (index) {
    case 0: return {
      type: SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS,
      data: response?.data || [],
      fetchAllError: undefined,
    };
    case 1: return {
      type: SHIPMENT_EXECUTION_SET_VGM_REQUESTS,
      data: response?.data || [],
      fetchAllError: undefined,
    };
    case 2: return {
      type: SHIPMENT_EXECUTION_SET_FORM13_REQUESTS,
      data: response?.data || [],
      fetchAllError: undefined,
    };
    default: return;
  }
}

export const fetchAllSEDocuments = (shipmentId, isDraft?, tabToOpen?) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_SET_SI_LOADING,
    data: true,
  });
  const responses : any = await Promise.all([
    fetchShipmentInstructions(shipmentId),
    fetchVGMRequests(shipmentId),
    fetchAllForm13Requests(shipmentId),
  ])
  batch(() => {
    let siData;
    let vgmData;
    responses.forEach(async (response, index) => {
      if (response.isSuccess) {
        if (index === 0) {
          siData = response.data;
        }
        if (index === 1) {
          vgmData = response.data;
        }
        dispatch(getIndexWiseShipmentActions(index, response));
        if (isValidArray(response.data)) {
          let requestId = response.data[0]?.id;
          if (isDraft) {
            requestId = response.data?.find(item => item.isDraft)?.id || requestId;
          }
          if (index === 0 && (!tabToOpen || tabToOpen === 'SI')) {
            await dispatch(fetchShipmentInstructionDetails(shipmentId, requestId))
          } else if (index === 1 && (tabToOpen === 'VGM' || !isValidArray(siData))) {
            await dispatch(fetchVGMRequestDetails(requestId))
          } else if (index === 2 && (tabToOpen === 'FORM13' || (!isValidArray(siData) && !isValidArray(vgmData)))) {
            await dispatch(fetchForm13RequestDetails(requestId))
          }
        }
      } else {
        dispatch({
          type: index === 0 ? SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS :
            (index === 1 ? SHIPMENT_EXECUTION_SET_VGM_REQUESTS : SHIPMENT_EXECUTION_SET_FORM13_REQUESTS),
          fetchAllError: response?.errorMessage,
        });
      }
    });
    dispatch({
      type: SHIPMENT_EXECUTION_SET_SI_LOADING,
      data: false,
    });
  })
}

export const fetchPendingContainerCount = (shipmentId) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING,
    isFetchingContainerCount: true,
  });
  const response = await fetchShipmentInstructionsPendingCount(shipmentId);
  if (response.isSuccess) {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT,
      data: response.data,
    });
  }
  dispatch({
    type: SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING,
    isFetchingContainerCount: false,
  });
}

export const fetchShipmentInstructionDetails = (shipmentId, id, taskId?) => async (dispatch) => {
  const response = await fetchShipmentInstructionsDetails(shipmentId, id, taskId);
  if (response.isSuccess) {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_SI_DETAILS,
      data: response?.data || [],
      requestId: id,
      error: undefined,
      seDocumentType: 'SI',
    });
  } else {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_SI_DETAILS,
      error: response.errorMessage,
    });
  }
}

export const fetchVGMRequestDetails = (id) => async (dispatch) => {
  const response = await fetchVGMDetails(id);
  if (response.isSuccess) {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_VGM_DETAILS,
      data: response?.data || [],
      requestId: id,
      error: undefined,
      seDocumentType: 'VGM',
    });
  } else {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_VGM_DETAILS,
      error: response.errorMessage,
    });
  }
}

export const setVesselMasters = (data) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_SET_VESSEL_MASTER,
    data: data || [],
  });
}

export const fetchForm13RequestDetails = (id) => async (dispatch) => {
  const response = await fetchForm13Request(id);
  if (response.isSuccess) {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_FORM13_DETAILS,
      data: response?.data || [],
      requestId: id,
      error: undefined,
      seDocumentType: 'FORM13',
    });
  } else {
    dispatch({
      type: SHIPMENT_EXECUTION_SET_FORM13_DETAILS,
      error: response.errorMessage,
    });
  }
}

export const setSelectedShipments = (data) => async (dispatch) => {
  dispatch({
    type: SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS,
    data: data || {},
  });
}